import React, {memo} from 'react';
import CloseButtonSVG from '../components/CloseButtonSVG';
import Clock from '../assets/svgs/Clock';
import Pin from '../assets/svgs/Pin';
import Direction from '../assets/svgs/Direction';
import TypographyBody from '../components/Typography/TypographyBody';
import styled from 'styled-components';
import {PositionDetail} from '../types/vwCelebration';

type InfoWindowProps = {
  infoWindow?: PositionDetail;
  onClose?: () => void;
};

const Container = styled.div`
  position: absolute;
  min-width: 340px;
  background: white;
  transform: translate(-50%, -115%);
  padding: 12px;
  border-radius: 8px;
  z-index: 3;
`;

const CloseIcon = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const WindowChevron = styled.div`
  position: absolute;
  left: 50%;
  bottom: -12px;
  width: 25px;
  height: 12px;
  transform: translateX(-50%);

  &::after {
    content: '';
    position: absolute;
    height: 12px;
    left: 0;
    top: -1px;
    width: 25px;
    background-color: white;
    clip-path: polygon(0 0, 50% 100%, 100% 0);
  }
`;

const InfoWindow: React.FC<InfoWindowProps> = memo(({infoWindow, onClose}) => {
  const {datetime, tz, temp, latFormatted, lngFormatted, course, altitude} =
    infoWindow || {};
  const lat = latFormatted?.replace('&deg;', '°');
  const lng = lngFormatted?.replace('&deg;', '°');

  return (
    <Container>
      <CloseIcon>
        <CloseButtonSVG color="#000" onClick={onClose} />
      </CloseIcon>
      <Content>
        <Item>
          <Clock width={20} height={20} />
          <TypographyBody color="black" size="small" bold>{`${datetime} ${
            tz || ''
          }`}</TypographyBody>
        </Item>
        <Item>
          <Pin width={20} height={20} />
          <TypographyBody
            color="black"
            size="small"
          >{`${lat}, ${lng}/Course: ${course}°`}</TypographyBody>
        </Item>
        <Item>
          <Direction width={20} height={20} />
          <TypographyBody color="black" size="small">
            {`${temp}°C at ${altitude}m above sea level`}
          </TypographyBody>
        </Item>
      </Content>
      <WindowChevron />
    </Container>
  );
});

InfoWindow.displayName = 'InfoWindow';

export default InfoWindow;
